/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { isEmpty } from '../helper/is-empty.helper';

export function validateEmail(value: any): boolean {
  return isEmpty(value) || /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value);
}
